import React, { useEffect, useState } from 'react';
import { translate } from '@/services/TranslationService';

const AmountInput = ({ value, onChange, disabled }) => {
  const [displayValue, setDisplayValue] = useState((value / 100).toFixed(2));

  useEffect(() => {
    setDisplayValue((value / 100).toFixed(2));
  }, [value]);

  const handleChange = (e) => {
    setDisplayValue(e.target.value);
  };

  const handleBlur = () => {
    const raw = displayValue.replace(',', '.');
    const parsed = parseFloat(raw);
    if (!isNaN(parsed)) {
      onChange(Math.round(parsed * 100));
    } else {
      onChange(0);
    }
  };

  return (
    <div className="flex flex-col w-full max-w-md">
      <label className="mb-1 text-base font-semibold text-gray-700">
        {translate('Amount')}
      </label>
      <div className="relative">
        <span className="absolute inset-y-0 left-0 flex items-center m-1 p-3 text-gray-500 border-r border-l-gray-500 text-sm">
          {translate('€')}
        </span>
        <input
          type="text"
          inputMode="numeric"
          value={displayValue}
          disabled={disabled}
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder="0.00"
          className="pl-12 pr-3 py-2 border border-gray-300 rounded-md w-full focus:outline-none focus:ring focus:ring-blue-500"
        />
      </div>
    </div>
  );
};

export default AmountInput;
